webpackJsonp([177050494245383],{

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _TextBlock = __webpack_require__(24);
	
	var _TextBlock2 = _interopRequireDefault(_TextBlock);
	
	var _ProjectDetails = __webpack_require__(27);
	
	var _ProjectDetails2 = _interopRequireDefault(_ProjectDetails);
	
	var _ProjectHeader = __webpack_require__(28);
	
	var _ProjectHeader2 = _interopRequireDefault(_ProjectHeader);
	
	var _SingleImage = __webpack_require__(29);
	
	var _SingleImage2 = _interopRequireDefault(_SingleImage);
	
	var _AHref = __webpack_require__(17);
	
	var _AHref2 = _interopRequireDefault(_AHref);
	
	var _utsPreview_ = __webpack_require__(479);
	
	var _utsPreview_2 = _interopRequireDefault(_utsPreview_);
	
	__webpack_require__(345);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UTSWebMedia = function (_Component) {
	  _inherits(UTSWebMedia, _Component);
	
	  function UTSWebMedia() {
	    _classCallCheck(this, UTSWebMedia);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  UTSWebMedia.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_ProjectHeader2.default, {
	        heading: 'Updating a design subject',
	        client: 'University of Technology Sydney'
	      }),
	      _react2.default.createElement(_SingleImage2.default, { img: _utsPreview_2.default, margin: true }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'In 2016, the University of Technology Sydney (UTS) asked me to renew the learning materials and resources for their Bachelor of Design\u2019s \u2018Web Media 1\u2019 subject.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The project was part of a grant provided by ',
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'https://www.uts.edu.au/research-and-teaching/learning-and-teaching/learningfutures/overview' },
	            'learning.futures'
	          ),
	          ', a university-wide initiative to blending the best of online and face-to-face learning experiences and activities to prepare graduates for the evolving technological demands of the global workplace.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Over the course of two weeks, I updated existing course material, sourced and created new resources aligned with best practices in the fields of user experience design, interaction design, information architecture, user interface design and front-end development.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I wrote a new subject outline and updated the student\u2019s learning portal to reflect the subject\u2019s new structure and content.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Implemented as of 2017, the newly refreshed subject offers the most relevant learning materials and resources in professional website design and website development practices, and explores them in relation to the commercial practices of user interface design, interaction design, user experience design and information architecture.'
	        )
	      )
	    );
	  };
	
	  return UTSWebMedia;
	}(_react.Component);
	
	UTSWebMedia.propTypes = {
	  children: _react.PropTypes.node
	};
	
	exports.default = UTSWebMedia;
	module.exports = exports['default'];

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uts-preview_1600.c716651d.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-uts-web-media-index-js-6eb9e617c2abfef11fe4.js